import React from 'react';
import { Link } from 'react-router-dom';

const Softwares: React.FC = () => {
  return (
    <div className="space-y-12">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold">
          <span className="gradient-text">Our Solutions</span>
        </h1>
        <p className="text-slate-600 text-lg max-w-2xl mx-auto">
          Cutting-edge software products designed for modern businesses.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-8">
        <div className="glass-card space-y-6">
          <div className="space-y-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 
                          flex items-center justify-center text-white font-bold text-xl">
              S
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900">SurveyMyStore</h2>
              <p className="text-slate-600 mt-2">
                Next-generation feedback collection platform with AI-powered insights 
                and seamless store integration.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-slate-50 p-4 border border-slate-200/50">
                <div className="text-brand-600 font-semibold mb-1">Smart Timing</div>
                <div className="text-slate-600 text-sm">AI-driven engagement detection</div>
              </div>
              <div className="rounded-lg bg-slate-50 p-4 border border-slate-200/50">
                <div className="text-brand-600 font-semibold mb-1">Analytics</div>
                <div className="text-slate-600 text-sm">Real-time insights dashboard</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-slate-50 p-4 border border-slate-200/50">
                <div className="text-brand-600 font-semibold mb-1">Customizable</div>
                <div className="text-slate-600 text-sm">Branded UI components</div>
              </div>
              <div className="rounded-lg bg-slate-50 p-4 border border-slate-200/50">
                <div className="text-brand-600 font-semibold mb-1">Integration</div>
                <div className="text-slate-600 text-sm">Simple SDK implementation</div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4 pt-4">
            <Link to="/softwares/surveymystore" className="btn-primary">
              Learn More
            </Link>
            <Link to="/softwares/surveymystore/terms" className="btn-secondary">
              Terms
            </Link>
          </div>
        </div>

        {/* Coming Soon Card */}
        <div className="glass-card space-y-6 opacity-75">
          <div className="space-y-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-slate-400 to-slate-500 
                          flex items-center justify-center text-white font-bold text-xl">
              ?
            </div>
            <div>
              <div className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-600 mb-2">
                Coming Soon
              </div>
              <h2 className="text-2xl font-bold text-slate-900">CloudMetrics</h2>
              <p className="text-slate-600 mt-2">
                Advanced cloud infrastructure monitoring and optimization platform.
                Join the waitlist to get early access.
              </p>
            </div>
          </div>

          <div className="pt-4">
            <button className="btn-secondary opacity-75 cursor-not-allowed" disabled>
              Join Waitlist
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Softwares;